import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import api from "../../../api";

const FacultyWiseReports = ({ uid }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [userdata, setUserData] = useState([]);
  const tableRefs = useRef([]);
  const navigate = useNavigate(); // Initialize useNavigate

  const addToRefs = (el) => {
    if (el && !tableRefs.current.includes(el)) {
      tableRefs.current.push(el);
    }
  };

  // Fetch academic years on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/users/getacademicyear/${uid}`);
        setData(res.data);
      } catch (err) {
        console.error("Error fetching academic years:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [uid]);

  // Fetch course data whenever selectedYear changes
  useEffect(() => {
    if (!selectedYear) return;

    const CourseChange = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/reports/getuserbybranch/${uid}`, {
          params: { selectedYear },
        });
        setUserData(res.data);
      } catch (err) {
        console.error("Error fetching course data:", err);
      } finally {
        setLoading(false);
      }
    };

    CourseChange();
  }, [selectedYear, uid]);

  // Handle click to navigate to user details
  const handleUserClick = (userid,depart,teacher_name) => {
    navigate("/userwisedetails", { state: { userid ,selectedYear,depart,teacher_name} });
  };

  return (
    <div className="w-full mt-8">
      <h1 className="text-2xl font-bold mb-6 text-center">
        Faculty Wise Reports
      </h1>

      {loading ? (
        <p className="text-blue-500 text-center">Loading academic years...</p>
      ) : (
        <div className="w-full max-w-md mx-auto mb-8">
          <label
            htmlFor="academicYear"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Select Academic Year:
          </label>
          <select
            id="academicYear"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="block w-full p-2.5 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="" disabled>
              -- Select Academic Year --
            </option>
            {data.map((item, index) => (
              <option key={index} value={item.academic_year}>
                {item.academic_year}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Display Users */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 px-4">
        {userdata.map((user, index) => (
          <div
            key={index}
            className="bg-purple-200 p-4 rounded shadow-md hover:bg-purple-300 cursor-pointer"
            onClick={() => handleUserClick(user.userid,user.depart,user.teacher_name)}
          >
            <h2 className="text-lg font-semibold text-gray-700">
              {user.teacher_name}
            </h2>
            <p className="text-sm text-gray-500">User ID: {user.userid}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FacultyWiseReports;
